import React, { useCallback, useEffect, useMemo, useState } from "react";
import {
  Avatar,
  Box,
  Button,
  Card,
  CardContent,
  Divider,
  FormControl,
  Dialog,
  DialogContent,
  FormControlLabel,
  Grid,
  IconButton,
  ListItemAvatar,
  MenuItem,
  Radio,
  RadioGroup,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { Link, useNavigate } from "react-router-dom";
import useErrorHandler from "../../hooks/useErrorHandler";
import { Form, Submit, useForm } from "../../hooks/useForm/useForm";
import axios from "axios";
import { useMessage } from "../../components/Header";
import { SelectWithSearch } from "../../components/Select";
import { Input } from "../../hooks/useForm/inputs";
// import { useTheme } from "@mui/material/styles";
import OutlinedInput from "@mui/material/OutlinedInput";
import Select from "@mui/material/Select";
import { CgClose } from "react-icons/cg";
import { useTheme } from "../../style/theme";
import { IoArrowBack } from "react-icons/io5";
import { styled } from "@mui/material/styles";
import Switch, { SwitchProps } from "@mui/material/Switch";

const AddPayrollPage = ({
  openAddModal,
  setOpenAddModal,
  fetchEmployeeSalary,
}) => {
  const [employees, setEmployees] = useState({});
  const errorHandler = useErrorHandler();
  const navigate = useNavigate();
  const [selectedFrequency, setSelectedFrequency] = useState("");
  const [selectedTime, setSelectedTime] = useState("");
  const [selected, setSelected] = useState("none");

  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
  };

  const salaryType = ["Salary", "Training", "Internship", "Hourly"];
  const frequency = ["100hp", "150hp", "120hp", "130hp"];
  const Time = ["11:00", "12:00", "13:00", "14:00", "15:00", "16:00", "17:00"];

  const handlers = useForm(
    useMemo(
      () => ({
        employeeId: { required: true },
        from: { required: true },
        to: { required: true },
        salary: { required: true },
        salaryType: { required: true },
        status: { required: true, value: "unPaid" },
        hraAllowance: { required: true },
        conveyance: { required: true },
        medicalAllowance: { required: true },
        bonusAllowance: { required: true },
        pf: { required: true },
        professionalTax: { required: true },
        tds: { required: true },
        loanAndOthers: { required: true },
        designation: { required: true },
      }),
      []
    ),
    { Input: TextField }
  );

  const values = handlers.values;
  const setValues = handlers.setValues;

  const fetchEmployees = useCallback(
    async (employeeSearch = "") => {
      try {
        const response = await axios.get(
          `/hr/employee?pageSize=10${
            employeeSearch ? `&searchBy=firstName&search=${employeeSearch}` : ""
          }`
        );

        setEmployees([]);
        const employees = response.data.employees;

        const formattedEmployees = {};

        employees.forEach(
          (employee) =>
            (formattedEmployees[
              employee._id
            ] = `${employee.firstName} ${employee.lastName}`)
        );

        setEmployees(formattedEmployees);
      } catch (e) {
        console.log(e);
      }
    },
    [setEmployees]
  );

  useEffect(() => {
    fetchEmployees();
  }, [fetchEmployees]);

  const handleChangeQuery = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setValues({ [name]: value });
  };

  const { showSuccess, showError } = useMessage();
  const submit = (res) => {
    const { success } = res.data;
    if (!success) return showError("payroll not added");
    // navigate('/employeesalary');
    showSuccess("Add payroll successfully");
    setOpenAddModal(false);
    fetchEmployeeSalary();
  };

  const calculatedSalary = useMemo(() => {
    const {
      hraAllowance,
      medicalAllowance,
      conveyance,
      bonusAllowance,
      pf,
      professionalTax,
      tds,
      loanAndOthers,
      salary,
    } = values;
    const totalAllowance =
      parseFloat(hraAllowance) +
        parseFloat(medicalAllowance) +
        parseFloat(conveyance) +
        parseFloat(bonusAllowance) || 0;
    const totalDeduction =
      parseFloat(pf) +
        parseFloat(professionalTax) +
        parseFloat(tds) +
        parseFloat(loanAndOthers) || 0;
    const netSalary = parseInt(salary) + totalAllowance - totalDeduction || 0;

    return { totalAllowance, totalDeduction, netSalary };
  }, [values]);

  const { mode } = useTheme();


const IOSSwitch = styled((props) => (
    <Switch
      focusVisibleClassName=".Mui-focusVisible"
      disableRipple
      {...props}
    />
  ))(({ theme }) => ({
    width: "42px",
    height: "24px",
    padding: 0,
    "& .MuiSwitch-switchBase": {
      padding: 0,
      margin: 2,
      transitionDuration: "300ms",
      "&.Mui-checked": {
        transform: "translateX(16px)",
        color: "#fff",
        "& + .MuiSwitch-track": {
          backgroundColor: "#3767B1",
          opacity: 1,
          border: 0,
          ...theme.applyStyles("dark", {
            backgroundColor: "#3767B1",
          }),
        },
        "&.Mui-disabled + .MuiSwitch-track": {
          opacity: 0.5,
        },
      },
      "&.Mui-focusVisible .MuiSwitch-thumb": {
        color: "#33cf4d",
        border: "6px solid #fff",
      },
      "&.Mui-disabled .MuiSwitch-thumb": {
        color: theme.palette.grey[100],
        ...theme.applyStyles("dark", {
          color: theme.palette.grey[600],
        }),
      },
      "&.Mui-disabled + .MuiSwitch-track": {
        opacity: 0.7,
        ...theme.applyStyles("dark", {
          opacity: 0.3,
        }),
      },
    },
    "& .MuiSwitch-thumb": {
      boxSizing: "border-box",
      width: "22px",
      height: "20px",
    },
    "& .MuiSwitch-track": {
      borderRadius: 26 / 2,
      backgroundColor: "#3767B1",
      opacity: 1,
      transition: theme.transitions.create(["background-color"], {
        duration: 500,
      }),
      ...theme.applyStyles("dark", {
        backgroundColor: "#39393D",
      }),
    },
  }));

  const [isRecurring, setIsRecurring] = useState(false); // default off



  return (
    <>
      <Dialog
        open={openAddModal}
        onClose={() => setOpenAddModal(false)}
        fullScreen
        // sx={{
        //   "& .MuiDialog-paper": {
        //     backgroundColor: mode == "dark" ? "#141414" :"",
        //   },
        // }}
      >
        <DialogContent
          sx={{ backgroundColor: mode === "dark" ? "#141414" : "" }}
        >
          <div className=" flex justify-between items-center mb-2">
            <div className="flex items-center gap-2">
              <IoArrowBack
                className="cursor-pointer"
                onClick={() => setOpenAddModal(false)}
              />
              <h2 className="my-3 font-semibold">Add New Payroll</h2>
            </div>
          </div>

          <Form
            handlers={handlers}
            onSubmit={submit}
            action="/hr/payslip"
            method="post"
            onError={errorHandler}
          >
            {/* salary */}
            <div>
              <p className={`${mode === "dark" ? "text-[#A5A5A5]" : ""} mb-4`}>
                Salary Information
              </p>
              <div className="flex flex-col xsx:flex-row justify-between gap-2 items-center">
                <div className="w-full">
                  <div className="mb-1">
                    <Typography variant="body2">Employee Name</Typography>
                  </div>

                  <div>
                    <FormControl fullWidth size="small">
                      <SelectWithSearch
                        name="employeeId"
                        fullWidth
                        displayEmpty
                        value={values.employeeId}
                        onChange={handleChangeQuery}
                        renderValue={(v) => {
                          if (!values.employeeId) {
                            return (
                              <span style={{ color: "#9e9e9e" }}>
                                Select employee
                              </span>
                            );
                          }
                          return employees[v];
                        }}
                        SearchProps={{
                          onChange: (e) => fetchEmployees(e.target.value),
                        }}
                      >
                        {Object.keys(employees).map((employee, i) => (
                          <MenuItem
                            value={employee}
                            key={i}
                            selected={false}
                            sx={{ px: 1.2 }}
                          >
                            <ListItemAvatar
                              sx={{
                                minWidth: "45px",
                              }}
                            >
                              <Avatar
                                alt="Remy Sharp"
                                src="data:image/jpeg;base64,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"
                                sx={{
                                  width: 30,
                                  height: 30,
                                }}
                              />
                            </ListItemAvatar>{" "}
                            {employees[employee]}
                          </MenuItem>
                        ))}
                      </SelectWithSearch>
                    </FormControl>
                  </div>
                </div>

                <div className="w-full">
                  <div>
                    <Typography variant="body2" sx={{ marginBottom: "4px" }}>
                      Designation
                    </Typography>

                    <Input
                      size="small"
                      placeholder="Enter designation"
                      name="designation"
                      fullWidth
                      type="text"
                    />
                  </div>
                </div>
              </div>

              <div className="flex flex-col xsx:flex-row justify-between gap-2  ">
                <div className="w-full">
                  <Typography variant="body2" sx={{ marginBottom: "4px" }}>
                    Salary Type
                  </Typography>

                  <div item lg={9} xs={12}>
                    <FormControl fullWidth size="small">
                      <Select
                        name="salaryType"
                        displayEmpty
                        value={values.salaryType}
                        onChange={handleChangeQuery}
                        input={<OutlinedInput />}
                        renderValue={(selected) => {
                          if (selected?.length === 0) {
                            return "--";
                          }

                          return selected;
                        }}
                        MenuProps={MenuProps}
                        inputProps={{ "aria-label": "Without label" }}
                      >
                        {/* <MenuItem disabled value="">
                                                <em>Placeholder</em>
                                            </MenuItem> */}
                        {salaryType.map((stype) => (
                          <MenuItem
                            key={stype}
                            value={stype}
                            // style={getStyles(stype, personstype, theme)}
                          >
                            {stype}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </div>
                </div>

                <div className="w-full">
                  <Typography variant="body2" sx={{ marginBottom: "4px" }}>
                    Salary ($)
                  </Typography>

                  <Input
                    size="small"
                    placeholder="0"
                    name="salary"
                    type="number"
                    fullWidth
                    required
                  />
                </div>
              </div>

              <div className="flex flex-col xsx:flex-row justify-between gap-2 items-center ">
                <div className="w-full">
                  <Typography variant="body2" sx={{ marginBottom: "4px" }}>
                    From
                  </Typography>

                  <Input
                    size="small"
                    name="from"
                    type="date"
                    fullWidth
                    required
                  />
                </div>

                <div className="w-full">
                  <Typography variant="body2" sx={{ marginBottom: "4px" }}>
                    To
                  </Typography>

                  <Input
                    size="small"
                    name="to"
                    type="date"
                    fullWidth
                    required
                  />
                </div>
              </div>

              <Grid item xs={12}>
                <Typography variant="body2">Status :</Typography>
              </Grid>
              <Grid item xs={12}>
                <FormControl sx={{ display: "flex" }}>
                  <RadioGroup
                    row
                    defaultValue={values.status}
                    name="status"
                    onChange={handleChangeQuery}
                  >
                    <FormControlLabel
                      sx={{ fontWeight: "400" }}
                      value="paid"
                      control={<Radio />}
                      label="Paid"
                    />
                    <FormControlLabel
                      sx={{ marginLeft: "15px", fontWeight: "400" }}
                      value="unPaid"
                      control={<Radio />}
                      label="UnPaid"
                    />
                  </RadioGroup>
                </FormControl>
              </Grid>
            </div>

            <div className="my-6 ">
              <div className="flex gap-2">
                <p className="font-[600] text-[18px]">
                  Make this a recurring transfer?
                </p>
                <IOSSwitch checked={isRecurring} onChange={(e) => setIsRecurring(e.target.checked)} />

              </div>
              {isRecurring && (
              <div>
              <div className="w-full mt-3">
                <Typography variant="body2" sx={{ marginBottom: "4px" }}>
                  Frequency
                </Typography>

                <div item lg={9} xs={12}>
                  <FormControl fullWidth size="small">
                    <Select
                      name="frequency"
                      displayEmpty
                      value={selectedFrequency} // <-- selected value yahan
                      onChange={(e) => setSelectedFrequency(e.target.value)} // <-- handle change
                      input={<OutlinedInput />}
                      renderValue={(selected) => {
                        if (!selected) {
                          return (
                            <span style={{ color: "#9e9e9e" }}>Select</span>
                          ); // placeholder color
                        }
                        return selected;
                      }}
                      MenuProps={MenuProps}
                      inputProps={{ "aria-label": "Without label" }}
                    >
                      {frequency.map((stype) => (
                        <MenuItem key={stype} value={stype}>
                          {stype}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </div>
              </div>

              <div className="w-full mt-3">
                <Typography variant="body2" sx={{ marginBottom: "4px" }}>
                  Time of the Day
                </Typography>

                <div item lg={9} xs={12}>
                  <FormControl fullWidth size="small">
                    <Select
                      name="Time"
                      displayEmpty
                      value={selectedTime} // <-- selected value yahan
                      onChange={(e) => setSelectedTime(e.target.value)} // <-- handle change
                      input={<OutlinedInput />}
                      renderValue={(selected) => {
                        if (!selected) {
                          return (
                            <span style={{ color: "#9e9e9e" }}>00:00:00</span>
                          ); // placeholder color
                        }
                        return selected;
                      }}
                      MenuProps={MenuProps}
                      inputProps={{ "aria-label": "Without label" }}
                    >
                      {Time.map((stype) => (
                        <MenuItem key={stype} value={stype}>
                          {stype}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </div>
              </div>

              <div className="mt-5">
                <p>
                  What should happen if the funds are not sufficient on
                  execution time?
                </p>
                <div className="flex gap-[100px]">
                  <label
                    className={`flex items-center gap-[10px] p-3 cursor-pointer transition-all`}
                  >
                    <input
                      type="radio"
                      name="transferOption"
                      value="none"
                      checked={selected === "none"}
                      onChange={() => setSelected("none")}
                      className="mt-1 accent-[#A5A5A5]"
                    />
                    <div className="flex flex-col">
                      <span className="text-sm font-medium">
                        Do not execute
                      </span>
                      <span className="text-xs text-gray-400">
                        Money will not be transferred
                      </span>
                    </div>
                  </label>

                  <label
                    className={`flex items-center gap-[10px] p-3 cursor-pointer transition-all `}
                  >
                    <input
                      type="radio"
                      name="transferOption"
                      value="transfer"
                      checked={selected === "transfer"}
                      onChange={() => setSelected("transfer")}
                      className="mt-1 accent-[#A5A5A5]"
                    />
                    <div className="flex flex-col">
                      <span className="text-sm font-medium">
                        Transfer what is available
                      </span>
                      <span className="text-xs text-gray-400">
                        All available balance will be transferred
                      </span>
                    </div>
                  </label>
                </div>
              </div>

              <div className="mt-5">
                <p>Terms and Conditions</p>
                <div className="flex items-center gap-5">
                  <input type="checkbox" />
                  <label>I agree to the terms and conditions governing this transfer method</label>

                </div>
              </div>
              </div>
              )}
              
            </div>

            {/* allowances */}
            <p className={`${mode === "dark" ? "text-[#A5A5A5]" : ""} my-2`}>
              Allowances
            </p>

            <div className="flex flex-col xsx:flex-row justify-between gap-2 items-center">
              <div className="w-full">
                <Typography variant="body2" sx={{ marginBottom: "4px" }}>
                  HRA Allowance
                </Typography>

                <Input
                  size="small"
                  placeholder="0"
                  name="hraAllowance"
                  type="number"
                  fullWidth
                />
              </div>

              <div className="w-full">
                <Typography variant="body2" sx={{ marginBottom: "4px" }}>
                  Conveyance
                </Typography>

                <Input
                  size="small"
                  placeholder="0"
                  name="conveyance"
                  fullWidth
                  type="number"
                  // required
                />
              </div>
            </div>

            <div className="flex flex-col xsx:flex-row justify-between gap-2 items-center">
              <div className="w-full">
                <Typography variant="body2" sx={{ marginBottom: "4px" }}>
                  Medical Allowance
                </Typography>

                <Input
                  size="small"
                  placeholder="0"
                  name="medicalAllowance"
                  fullWidth
                  type="number"
                  // required
                />
              </div>

              <div className="w-full">
                <Typography variant="body2" sx={{ marginBottom: "4px" }}>
                  Bonus Allowance
                </Typography>

                <Input
                  size="small"
                  placeholder="0"
                  name="bonusAllowance"
                  fullWidth
                  type="number"
                  // required
                />
              </div>
            </div>

            {/* Deucation */}
            <p className={`${mode === "dark" ? "text-[#A5A5A5]" : ""} my-2`}>
              Deduction
            </p>

            <div className="flex flex-col xsx:flex-row justify-between gap-2 items-center">
              <div className="w-full">
                <Typography variant="body2" sx={{ marginBottom: "4px" }}>
                  PF
                </Typography>
                <Input size="small" placeholder="0" name="pf" fullWidth />
              </div>

              <div className="w-full">
                <Typography variant="body2" sx={{ marginBottom: "4px" }}>
                  Professional Tax
                </Typography>

                <Input
                  size="small"
                  placeholder="0"
                  name="professionalTax"
                  fullWidth
                  type="number"
                />
              </div>
            </div>

            <div className="flex flex-col xsx:flex-row justify-between gap-2 items-center">
              <div className="w-full">
                <Typography variant="body2" sx={{ marginBottom: "4px" }}>
                  TDS
                </Typography>
                <Input
                  size="small"
                  placeholder="0"
                  name="tds"
                  type="number"
                  fullWidth
                />
              </div>

              <div className="w-full">
                <Typography variant="body2" sx={{ marginBottom: "4px" }}>
                  Loans & Others
                </Typography>
                <Input
                  size="small"
                  placeholder="0"
                  name="loanAndOthers"
                  type="number"
                  fullWidth
                />
              </div>
            </div>

            {/* Gross salary */}

            <p className={`${mode === "dark" ? "text-[#A5A5A5]" : ""} my-2`}>
              Gross Salary
            </p>

            <div className="flex items-center gap-3 mb-2">
              <Typography variant="body2">Total Allowances:</Typography>

              <p className={`${mode === "dark" ? "text-[#A5A5A5]" : ""}`}>
                {calculatedSalary.totalAllowance}
              </p>
            </div>

            <div className="flex items-center gap-3 mb-2">
              <Typography variant="body2">Total Deduction</Typography>

              <p className={`${mode === "dark" ? "text-[#A5A5A5]" : ""}`}>
                {calculatedSalary.totalDeduction}
              </p>
            </div>

            <div className="flex gap-3 items-center mb-2">
              <Typography variant="body2">Net Salary</Typography>

              <p className={`${mode === "dark" ? "text-[#A5A5A5]" : ""}`}>
                {calculatedSalary.netSalary}
              </p>
            </div>

            <div className="flex justify-end">
              <div>
                <Button
                  variant="outlined"
                  color="error"
                  sx={{
                    width: { md: "90px", xs: "80px" },
                  }}
                >
                  Delete
                </Button>
                <Submit>
                  {(loader) => (
                    <Button
                      type="submit"
                      disabled={Boolean(loader)}
                      endIcon={loader}
                      variant="contained"
                      sx={{
                        mx: 2,
                        backgroundColor: "#0080FF",
                        "$:hover": {
                          background: "#4674FF",
                        },
                        width: { md: "90px", xs: "80px" },
                      }}
                    >
                      Save
                    </Button>
                  )}
                </Submit>
              </div>
            </div>
          </Form>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default AddPayrollPage;
